/* eslint-disable import/no-absolute-path */
/* eslint-disable import/no-unresolved */
import kotlinSVG from 'assets/resources/pages/software-services/logo/kotlin2.svg';
import swiftSVG from 'assets/resources/pages/software-services/logo/swift2.svg';

export default [
  {
    src: kotlinSVG,
    nameClass: 'img-fluid',
    alt: 'Kotlin'
  },
  {
    src: swiftSVG,
    nameClass: 'img-fluid',
    alt: 'Swift'
  }
]